export const SIZES = {
  /** 4 */
  SIZE_4: '4px',
  /** 6 */
  SIZE_6: '6px',
  /** 14 */
  SIZE_14: '14px',
  /** 32 */
  SIZE_32: '32px',
  /** 44 */
  SIZE_44: '44px',
};
